import { BulkDrawerFormFieldsMap } from '../BulkEmailForm/fields';

export const BULK_DRAWER_ERRORS_KEYS = {
  wellWrittenSmartTags: 'wellWrittenSmartTags',
  atLeastOneSmartTag: 'atLeastOneSmartTag'
};

export const REQUIRED_BULK_FIELD_KEYS = [
  BulkDrawerFormFieldsMap.To.key,
  BulkDrawerFormFieldsMap.BulkScope.key,
  BulkDrawerFormFieldsMap.Subject.key,
  BulkDrawerFormFieldsMap.EmailBody.key
];
